export default "__VITE_ASSET__SRK6y7Fb__"